import { FC } from 'react';

interface Props {
  onExport: () => void;
  /** Habilita só quando já existe um resultado de DRL na conversa pra exportar. */
  disabled?: boolean;
}

/**
 * Botão "Exportar DRL anotado" (Frente 5, S06). Dispara o `export_drl_result` (S05)
 * via mensagem do chat — o backend lê o `drl_result` persistido e devolve o .xlsx
 * (chip de download). Fica desabilitado enquanto não há resultado pra exportar.
 */
const DrlExportButton: FC<Props> = ({ onExport, disabled }) => (
  <button
    type="button"
    data-testid="drl-export-button"
    onClick={onExport}
    disabled={disabled}
    title={
      disabled
        ? 'Confira um DRL antes de exportar a planilha'
        : 'Exportar o DRL anotado (.xlsx) com status, links e observações'
    }
    className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg bg-accent text-surface-primary font-semibold hover:opacity-90 transition disabled:opacity-40 disabled:cursor-not-allowed"
  >
    <span className="material-symbols-outlined text-base leading-none">table_chart</span>
    Exportar DRL anotado
  </button>
);

export default DrlExportButton;
